import { useEffect, useRef, useState } from 'react'

export const useStateWithCallback = initialValue => {
  const callbackRef = useRef(null)

  const [value, setValue] = useState({
    value: initialValue,
    flag: false,
  })

  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(value)

      callbackRef.current = null
    }
  }, [value])

  const setValueWithCallback = (newValue, callback) => {
    callbackRef.current = callback
    const valueObj = {
      value: newValue,
      flag: !value.flag,
    }
    return setValue(valueObj)
  }

  return [value.value, setValueWithCallback]
}
